import * as M from "../Model/overviewModel"
import { cmd } from "elm-ts"
import { Variant } from "@flypengine/myFlyp-lib"
import { pipe } from "fp-ts/function"
import * as O from "fp-ts/Option"
import * as E from "fp-ts/Either"

export const initModel: M.Model = M.overviewInitModel(E.left("Not Attempted"))
export const initCmd: cmd.Cmd<M.Msg> = cmd.of(M.Msg.init())

export const update: <msg>(
  config: M.Config<msg>
) => (msg: M.Msg) => (model: M.Model) => [M.Model, cmd.Cmd<msg>] =
  config => msg => model =>
    pipe(
      msg,
      Variant.caseOf({
        [M._init]: () => [
          model,
          cmd.of(config.dealOverviewMsg(config.propcode)),
        ],
        [M._lastFocused]: lastFocused => [
          pipe(
            model,
            E.map(prevModel => ({ ...prevModel, lastFocused }))
          ),
          cmd.none,
        ],
        [M._modalContents]: modalContents => [
          pipe(
            model,
            E.map(prevModel => ({ ...prevModel, modal: modalContents }))
          ),
          pipe(
            modalContents,
            O.match(
              () =>
                pipe(
                  model,
                  E.match(
                    () => cmd.none,
                    prevModel =>
                      pipe(
                        prevModel.lastFocused,
                        O.match(
                          () => cmd.none,
                          lastFocused => {
                            document.getElementById(lastFocused)?.focus()
                            return cmd.none
                          }
                        )
                      )
                  )
                ),
              () => cmd.none
            )
          ),
        ],
        [M._agentsModel]: agentsModel => [
          pipe(
            model,
            E.map(prevModel => ({
              ...prevModel,
              agentsModel: O.some(agentsModel),
            }))
          ),
          cmd.none,
        ],
        [M._statusModel]: statusModel => [
          pipe(
            model,
            E.map(prevModel => ({ ...prevModel, statusModel }))
          ),
          cmd.none,
        ],
        [M._propertyWorthModel]: propertyWorthModel => [
          pipe(
            model,
            E.map(prevModel => ({
              ...prevModel,
              propertyWorth: propertyWorthModel,
            }))
          ),
          cmd.none,
        ],
      })
    )
